import { render } from "./newTickets.vue?vue&type=template&id=04f025f7&scoped=true"
import script from "./newTickets.vue?vue&type=script&lang=js"
export * from "./newTickets.vue?vue&type=script&lang=js"

import "./newTickets.vue?vue&type=style&index=0&id=04f025f7&scoped=true&lang=scss"
import "./newTickets.vue?vue&type=style&index=1&id=04f025f7&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f025f7"]])

export default __exports__